const STORED_TRUE = 'true'

export type AccountStorageFlag = {
  read: (accountId: string) => boolean
  write: (accountId: string) => void
}

export function createAccountStorageFlag(prefix: string): AccountStorageFlag {
  return {
    read: (accountId) => readStoredFlag(`${prefix}:${accountId}`),
    write: (accountId) => writeStoredFlag(`${prefix}:${accountId}`),
  }
}

/** Reading the `localStorage` global can itself throw where storage is blocked. */
function readStoredFlag(key: string): boolean {
  try {
    return localStorage.getItem(key) === STORED_TRUE
  } catch {
    return false
  }
}

function writeStoredFlag(key: string): void {
  try {
    localStorage.setItem(key, STORED_TRUE)
  } catch {
    // Private-mode and quota errors are non-fatal.
  }
}
